import { all, call, put, takeLatest } from "redux-saga/effects";
import JobPromotionService from "../../services/jobPromotion.service";
import { getJobPromotionsSuccess, getJobPromotionsFailed, updateJobPromotionStatusSuccess, updateJobPromotionStatusFailed } from "./jobPromotionSlice";
import { showErrorToaster, showSuccessToaster } from "../../helpers/utils/toaster";

function* jobPromotionWatcher() {
  yield takeLatest("jobPromotion/getJobPromotions", getJobPromotionsSaga);
  yield takeLatest("jobPromotion/updateJobPromotionStatus", updateJobPromotionStatusSaga);
}

function* getJobPromotionsSaga(action) {
  try {
    const response = yield call(JobPromotionService.getJobPromotions, action.payload);

    if (response.status) {
      yield put(getJobPromotionsSuccess(response.data));
    } else {
      yield put(getJobPromotionsFailed(response.message));
    }
  } catch (err) {
    console.log("Error: ", err);
    yield put(getJobPromotionsFailed("Failed to fetch promotions"));
  }
}

function* updateJobPromotionStatusSaga(action) {
  try {
    const response = yield call(JobPromotionService.updateJobPromotionStatus, action.payload);

    if (response.status) {
      yield put(updateJobPromotionStatusSuccess(action.payload));
      showSuccessToaster(response.message);
    } else {
      yield put(updateJobPromotionStatusFailed(response.message));
      showErrorToaster(response.message);
    }
  } catch (err) {
    console.log("Error: ", err);
    yield put(updateJobPromotionStatusFailed("Failed to update status"));
    showErrorToaster("Something went wrong");
  }
}

export default function* jobPromotionSaga() {
  yield all([jobPromotionWatcher()]);
}
